
<template>
    <div class="row p-3">
        <div class="col-xl-6 col-lg-6 col-md-5 col-xs-12">
            <div class="intr_text" style="font-weight:bold">
                Доступ до участі в тендерах буде надано після перевірки документів нашими спеціалістами.
                Дочекайтесь відповідного листа.
            </div>
            <div class="files_info">Додайте документи:<br>- Витяг/Виписка з ЄДР<br>- Статут<br>- Свідоцтво платника ПДВ<br>- Підтвердження повноважень підписанта (довіреність і т.д.)<br>- Банківські реквізити<br>- Наказ на призначення керівника<br>- Копії дозвільних документів, ліцензій</div>
        </div>
        <div class="col-xl-6 col-lg-6 col-md-7 col-xs-12">
            <BTable class="table-responsive-lg"    thead-class="bg-primary text-white"  striped :items="attachedFiles" :fields="attachedFilesFields">
                
                <template  v-slot:head(link)="data">
                    <span class="fs-xl text-center" v-html="data.label"></span>
                </template>
                
                <template v-slot:head(remove)="data">
                    <span class="fs-xl text-center" v-html="data.label"></span>
                </template>
                
                <template  v-slot:cell(link)="data" >
                <span class="get_file cursor-pointer" @click="getFile(data.item)">
                     <i class="fal fs-xl  fa-save save_me"></i>
                </span>
                </template>
                
                <template  v-slot:cell(remove)="data" >
                    <i class="fas fa-trash fs-xl cursor-pointer" @click="remove_file(data.item)" ></i>
                </template>
            
            </BTable>
        </div>
        
    </div>
  
    <div class="sb_doc_files p-3">
        <fileloader key="file_loader_mem" doc_type="profile_doc"
            :doc_id="this.user.id"
            :url_remove="contragent_file_url"
            :url_load="contragent_file_url"
            v-bind:trigger_load="file_trigger"
            v-bind:can_del="true"
            :enable-preview=false
            :simpleLoader="true"
            :files="[]"
        >
        </fileloader>
    </div>

</template>


<script>
import {mapGetters} from "vuex";
import fileloader from "../../../../shared/file_loader/fileloader.vue";
import {BTable,} from 'bootstrap-vue-next';

export default {
    name: "profile_files",
    emits: ['loading'],
    
    components : {
        fileloader,
        BTable
    },
    
    data() {
        return {
            "file_trigger" : "loadedDoc",
            attachedFiles : [],
            attachedFilesFields : [
                {
                    key: 'name',
                    label: 'Назва',
                    sortable: true
                },
                {
                    key: 'added',
                    label: 'Дата',
                    sortable: true
                },
                {
                    key : 'link',
                    label: '<i class="fal fa-save"></i>',
                    sortable: false
                },
                {
                    key : 'remove',
                    label: '<i class="fal fa-trash"></i>',
                    sortable: false
                },
            ],
        }
    },
    
    created() {
        EventBus.$on('user_loaded',this.loadFiles);
        EventBus.$on(this.file_trigger,this.loadFiles);
        
        if(this.userLoad.is_load) {
            this.loadFiles();
        }
        
    },
    
    methods: {
        
        async getFile(file) {
            console.log(file);
            window.location.href = '/internal/media/profile_file/' + file.id;
        },
        
        async remove_file(file) {
            IMC_CORE.showloading();
            await api.delete( this.contragent_file_url + '/' + file.id).then(({data}) => {
                if (data.status === "operation_success") {
                    this.loadFiles();
                   
                }
                
            }).catch(err => {
                IMC_CORE.hideloading();
                EventBus.$emit('show_toast', {err: err.message, type: "danger", title: err.status})
            });
        },
        
        async loadFiles() {
            const { data } = await api.get(this.contragent_file_url);
            if (data.status === "operation_success") {
                this.attachedFiles = data.data;
                IMC_CORE.hideloading();
            }
        },
    },
    
    computed : {
        
        contragent_file_url () {
            return '/tenders/contragent/users/' + this.user.id + '/files';
        },
        
        ...mapGetters({
            'userLoad' : 'user/getUserModule',
            'user': "user/getUser",
            'settings': "user/getUserTenderSettings",
        }),
        
        cur_files() {
            if(this.user.hasOwnProperty("profile_files")) {
                return this.user.profile_files;
            }
            return [];
        },
    }
}
</script>

<style scoped>

</style>